export default __webpack_public_path__ + "static/media/img-besprechungen-purple.67259195.jpg";